const { createPalette } = require('./helpers')
const { AVENIR_FONT } = require('./consts')

const theme = {
	breakpoints: {
		xs: 480,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1600,
	},
	colors: {
		primary: createPalette('#346A5A', {
			'000': '#edf2ef',
			100: '#dbe5e0',
			200: '#bbd0c6',
			300: '#62917c',
		}),
		gray: createPalette('#999898', {
			'000': '#f9f9f9',
			100: '#f5f5f5',
			200: '#e9e9e9',
			300: '#cccbcb',
			400: '#b7b6b6',
			900: '#000000',
		}),
		info: createPalette('#3d85c6'),
		error: createPalette('#cc0000'),
		success: createPalette('#73d13d'),
		warning: createPalette('#ffa940'),
	},
	typography: {
		family: AVENIR_FONT,
		sizes: {
			xxs: 10,
			xs: 12,
			sm: 14,
			md: 16,
			lg: 18,
			xl: 24,
			xxl: 30,
		},
		lineHeightBase: 1.5715,
	},
	heights: {
		xxs: 24, // radio
		xs: 24, // checkbox
		sm: 36, // avatar (sm)
		md: 48, // inputs, buttons (middle) - avatar (md)
		lg: 60, // avatar (lg), inputs/buttons (lg)
		xl: 80, // ?
		xxl: 100, // header
	},
	margins: {
		xxs: 4,
		xs: 8,
		sm: 16,
		md: 24,
		lg: 32,
		xl: 48,
		xxl: 64,
	},
	paddings: {
		xxs: 4,
		xs: 8,
		sm: 16,
		md: 24,
		lg: 32,
		xl: 48,
		xxl: 64,
	},
	radius: {
		sm: 4,
		md: 6,
		lg: 40,
	},
	easing: {
		baseIn: 'cubic-bezier(0.9, 0, 0.3, 0.7)',
		baseOut: 'cubic-bezier(0.7, 0.3, 0.1, 1)',
		in: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
		out: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
		inOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
		inBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
		outBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
		inOutBack: 'cubic-bezier(0.71, -0.46, 0.29, 1.46)',
		inCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.34)',
		outCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
		inOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
		inQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
		outQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
		inOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)',
	},
}

module.exports = theme
